import { Box, Stack, Typography } from "@mui/material";
import { IngredientsGroup } from "./IngredientsGroup";
import { formatWeightWithUnits } from "../../../utils";

export const IngredientsTab = ({
  ingredientGroups = [],
  globalData,
  ingredientQuery,
}) => {
  const isTotalFinishedWeight = ingredientQuery?.groups?.some(
    (group) => group?.has_boiling_weight
  );

  return (
    <Stack
      sx={{
        width: "100%",
        gap: "4px",
      }}
    >
      <Box
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        py="16px"
        height="50px"
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "21.78px",
            color: "#111C2B",
          }}
        >
          Ingredients
        </Typography>
      </Box>
      <Stack
        sx={{
          p: "0 8px 8px 8px",
          backgroundColor: "#F7FAFC",
          width: "100%",
        }}
      >
        {ingredientGroups?.map((ingredientGroup) => {
          return (
            <IngredientsGroup
              ingredientGroup={ingredientGroup}
              globalData={globalData}
              ingredientQuery={ingredientQuery}
            />
          );
        })}
      </Stack>

      <Box sx={{ borderRadius: "4px", overflow: "hidden" }}>
        {isTotalFinishedWeight === false ? (
          ""
        ) : (
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "16px",
              alignItems: "center",
              bgcolor: "#3372E5",
              p: "12px",
            }}
          >
            <Typography
              variant="subtitle1"
              color="#fff"
              fontWeight={500}
              fontSize={"14px"}
            >
              Finished Boiled Weight:
            </Typography>
            <Stack
              sx={{
                flexDirection: "row",
              }}
            >
              <Typography
                variant="h5"
                color="#fff"
                fontWeight={600}
                fontSize="18px"
              >
                {formatWeightWithUnits(
                  ingredientQuery?.total_weight,
                  ingredientQuery?.total_weight_unit,
                  globalData?.all_Units
                )}
              </Typography>
            </Stack>
          </Stack>
        )}
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            gap: "16px",
            alignItems: "center",
            bgcolor: isTotalFinishedWeight ? "#DFE8F2" : "#3372E5",
            p: "12px",
          }}
        >
          <Typography
            variant="subtitle1"
            color={isTotalFinishedWeight ? "#111C2B" : "#fff"}
            fontWeight={500}
            fontSize={"14px"}
          >
            Total Weight:
          </Typography>
          <Stack
            sx={{
              flexDirection: "row",
            }}
          >
            <Typography
              variant="h5"
              color={isTotalFinishedWeight ? "#111C2B" : "#fff"}
              fontWeight={600}
              fontSize="18px"
            >
              {formatWeightWithUnits(
                ingredientQuery?.total_ingredient_weight,
                ingredientQuery?.total_weight_unit,
                globalData?.all_Units
              )}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};
